module.exports = __webpack_public_path__ + "cadastral_certificate_example.478dfd4954bf12b2feee7ab03ea9d8bd.png";